import React, { useState, useEffect } from 'react';
import { loadData } from '../services/codeDataStore';
import LegalPageLayout from '../components/LegalPageLayout';

const Disclaimer = () => {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchDisclaimerContent();
  }, []);

  const fetchDisclaimerContent = async () => {
    try {
      const site = await loadData('site', {});
      if (site?.disclaimer) {
        setContent(site.disclaimer);
      } else {
        setError('Medical Disclaimer content not found.');
      }
    } catch (err) {
      setError('Failed to fetch disclaimer content.');
      console.error('Error fetching disclaimer content:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <LegalPageLayout
      title="Medical & Publication Disclaimer"
      subtitle="Clinical practice disclaimer, author liability limitation, and educational usage statement."
      content={content}
      loading={loading}
      error={error}
      activePolicy="disclaimer"
    />
  );
};

export default Disclaimer;